import { createFileRoute } from '@tanstack/react-router';
import { WhiteboardsHubPage } from '@/features/whiteboards/whiteboards-hub-page';

export const Route = createFileRoute('/w/$workspaceId/whiteboards/')({ component: WhiteboardsHubPage });
